import { render, staticRenderFns } from "./EmoteItem.vue?vue&type=template&id=c25262e2&scoped=true&"
import script from "./EmoteItem.vue?vue&type=script&lang=js&"
export * from "./EmoteItem.vue?vue&type=script&lang=js&"
import style0 from "./EmoteItem.vue?vue&type=style&index=0&id=c25262e2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25262e2",
  null
  
)

export default component.exports